import * as React from 'react';

import CheckmateApiClient from '../../services/apiClient';
import { CheckmateDialog } from '../../components/shared/dialog';
import { LocalRoutes } from '../../utilities/LocalRoutes';
import { Navigate } from 'react-router-dom';

const _apiClient = new CheckmateApiClient();

interface ILogoutProps {
    onLogout: () => void;
}

interface ILogoutState {
    redirect: boolean;
    redirectTo: string;
}

export class Logout extends React.Component<ILogoutProps, ILogoutState> {
    constructor(props: any) {
        super(props);

        this.state = {
            redirect: false,
            redirectTo: '/',
        };
    }

    handleConfirm = async () => {
        await _apiClient.logout();
        this.props.onLogout();
        this.setState({
            redirect: true,
            redirectTo: LocalRoutes.Login,
        });
    };

    handleClose = () => {
        this.setState({
            redirect: true,
            redirectTo: '/',
        });
    };

    public render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirectTo} />;
        } else {
            return (
                <CheckmateDialog
                    body="Are you sure you want to logout?"
                    cancelText="Cancel"
                    closeButtonClassName="btn btn-default"
                    confirmButtonClassName="btn btn-black"
                    confirmText="Logout"
                    dialogClassName="logout-dialog"
                    handleClose={this.handleClose}
                    handleConfirm={this.handleConfirm}
                    isShowingModal={true}
                    title="Logout"
                    showBackdrop
                />
            );
        }
    }
}
